import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a55ea308: FaireBrandEntity = {
  token: "b_a55ea308",
  type: "brand",
  name: "Dahlia Press",
  avatarUrl:
    "https://cdn.faire.com/fastly/9935e40389bb35f777c91ff2c6bba68608da3eac45298d0bdc444db9979b9ea3.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/daeb75baaf83997ed06922729ccd2b98762c50ef5827509ad30988ddda0dc442.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9935e40389bb35f777c91ff2c6bba68608da3eac45298d0bdc444db9979b9ea3.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/daeb75baaf83997ed06922729ccd2b98762c50ef5827509ad30988ddda0dc442.jpeg",
  location: "Seattle, WA, USA",
  minimumOrderDollars: 205,
  rating: 5,
  reviewCount: 77,
  isTopShop: true,
  isInsider: true,
  description:
    "Located in Seattle Washington, Dahlia Press is a boutique design and letterpress studio founded in 2008. After years of providing happy couples and families with custom invitations and announcements, in the summer of 2014, Dahlia Press began a small line of greetings and social stationery to expand its current offerings. Today our growing line includes over 400 greetings, and incorporates a variety of stationery goods such as wrapping paper, notepads, pens, and art prints. Using traditional letterpress printing methods combined with fresh and modern designs, we have developed a style sure to delight your customers.",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:01.971Z",
    importedBy: "entity-db-cli",
  },
};
